export var service = function($q,C) {
  var deferred;

  return {
    load: function() {
      if (deferred) { return deferred.promise; }

      deferred = $q.defer();
      var key = C.google_maps;

      window.initGoogleMaps = deferred.resolve;

      var script = document.createElement('script');
      script.src = "https://maps.googleapis.com/maps/api/js?key=" + key + "&callback=initGoogleMaps&libraries=drawing,places";

      if (!window.RAILS_ENV == 'test') {
        document.body.appendChild(script);
      } else {
        setTimeout(window.initGoogleMaps, 0);
      }

      return deferred.promise;
    }
  };
};

service.$inject = ['$q','C'];

tiz.service('GoogleMaps', service);
